{
  "EntityHoverCard": {
    "cantLoad": "Nie udało się wczytać szczegółów.",
    "openInSidebar": "Otwórz w panelu bocznym",
    "openFullPage": "Otwórz pełną stronę",
    "more": "+{{count}} więcej"
  },
  "ConfirmPopover": {
    "cancel": "Anuluj"
  },
  "RowList": {
    "reorderInstructions": "Aby zmienić kolejność, naciśnij Spację lub Enter, żeby podnieść „{{item}}”, przesuwaj strzałkami w górę i w dół, a potem naciśnij Spację lub Enter, żeby upuścić, albo Escape, żeby anulować.",
    "pickedUp": "Podniesiono „{{item}}”, pozycja {{position}} z {{count}}.",
    "notOver": "Poza pozycjami listy.",
    "moving": "Przesuwanie na pozycję {{position}} z {{count}}.",
    "droppedUnchanged": "Upuszczono. Kolejność się nie zmieniła.",
    "dropped": "Upuszczono na pozycji {{position}} z {{count}}.",
    "cancelled": "Anulowano. „{{item}}” zostaje na pozycji {{position}} z {{count}}.",
    "reorder": "Zmień kolejność: {{label}}",
    "remove": "Usuń: {{label}}"
  },
  "GlobalCustomFieldHint": {
    "ariaLabel": "Pole globalne",
    "tooltip": "To pole jest globalne. Zmiany będą widoczne we wszystkich przestrzeniach roboczych, do których przypisany jest ten zasób."
  },
  "FormSaveButton": {
    "save": "Zapisz"
  },
  "StickyFormActionsBar": {
    "toolbarLabel": "Akcje formularza",
    "hotkeyHintBefore": "Naciśnij",
    "hotkeyHintAfter": "aby zapisać zmiany",
    "cancel": "Anuluj"
  },
  "DialogErrorFooter": {
    "error": "Błąd"
  },
  "FormDialogContent": {
    "save": "Zapisz"
  },
  "EntityCreateDialog": {
    "back": "Wstecz",
    "next": "Dalej",
    "unsavedChanges": "Masz niezapisane zmiany!"
  },
  "ArchiveConfirmationDialog": {
    "archiveTitle": "Zarchiwizować {{entityName}}?",
    "unarchiveTitle": "Przywrócić {{entityName}}?",
    "archiveDescription": "Czy na pewno chcesz zarchiwizować ten {{entityName}}? Nie utracisz żadnych danych.",
    "unarchiveDescription": "Czy na pewno chcesz przywrócić ten {{entityName}}?",
    "archiveConfirm": "Archiwizuj",
    "unarchiveConfirm": "Przywróć",
    "cancel": "Anuluj",
    "confirmInProgress": "{{label}}…",
    "confirmRetry": "{{label}} (Ponów)",
    "srDescriptionArchive": "Okno potwierdzenia archiwizacji {{entityName}}.",
    "srDescriptionUnarchive": "Okno potwierdzenia przywracania {{entityName}}."
  },
  "CurrencyCombobox": {
    "placeholder": "Szukaj walut…",
    "empty": "Brak pasujących walut"
  },
  "TimezoneCombobox": {
    "placeholder": "Szukaj strefy czasowej…",
    "empty": "Brak pasujących stref czasowych"
  },
  "ImageUploadField": {
    "hint": "Upuść tu obraz lub kliknij kafelek.",
    "formats": "JPG lub PNG, do 10 MB",
    "upload": "Wgraj",
    "change": "Zmień",
    "uploading": "Wgrywanie…",
    "paste": "Wklej",
    "remove": "Usuń",
    "uploadError": "Nie udało się wgrać zdjęcia",
    "pasteEmpty": "W schowku nie ma obrazu",
    "pasteFailed": "Nie udało się odczytać schowka. Zaznacz kafelek i użyj skrótu wklejania."
  },
  "ImageCollectionUploadField": {
    "listLabel": "Przesłane pliki",
    "loading": "Wczytywanie plików",
    "emptyTitle": "Przeciągnij pliki tutaj lub kliknij, aby wybrać",
    "emptyTitleSingle": "Przeciągnij plik tutaj lub kliknij, aby wybrać",
    "formats": "{{formats}}, do {{size}} · wklej ⌘V nad galerią",
    "formatImages": "obrazy",
    "formatVideos": "filmy",
    "formatPdf": "dokumenty PDF",
    "formatAny": "dowolne pliki",
    "add": "Dodaj",
    "addHint": "przeciągnij · kliknij · ⌘V",
    "replace": "Zamień",
    "addHintOnHover": "kliknij albo wklej ⌘V",
    "dropToAdd": "Upuść, aby dodać",
    "reorder": "Zmień kolejność {{name}}",
    "select": "Zaznacz {{name}}",
    "remove": "Usuń {{name}}",
    "uploadFailed": "Wysyłanie nie powiodło się",
    "retry": "Ponów",
    "dismiss": "Odrzuć {{name}}",
    "rejected": "Nie można tu przesłać pliku {{name}}",
    "tooLarge": "{{name}} jest większy niż {{size}}",
    "open": "Otwórz plik",
    "removeShort": "Usuń",
    "noFiles": "Brak plików"
  },
  "FinancialDocumentDialog": {
    "addInvoice": "Dodaj fakturę",
    "addReceipt": "Dodaj paragon",
    "editInvoice": "Edytuj fakturę",
    "editReceipt": "Edytuj paragon",
    "create": "Utwórz",
    "invoice": "Faktura",
    "invoices": "Faktury",
    "receipt": "Paragon",
    "receipts": "Paragony",
    "expense": "Wydatek",
    "expensePlaceholder": "Wybierz wydatek",
    "reference": "Odnośnik",
    "referencePlaceholder": "Wpisz odnośnik",
    "amount": "Kwota",
    "status": "Status",
    "statusPlaceholder": "Wybierz status",
    "file": "Plik",
    "fileDescription": "Obsługiwane formaty PDF i obrazów",
    "upload": "Prześlij",
    "attachedReceipt": "Załączony paragon",
    "documentCount": "{{count}} dokument",
    "documentCount_other": "{{count}} dokumentów",
    "unsavedChanges": "Masz niezapisane zmiany w formularzu dokumentu finansowego.",
    "download": "Pobierz",
    "openInNewTab": "Otwórz w nowej karcie",
    "untitled": "Bez tytułu",
    "noFileAttached": "Brak załączonego pliku",
    "documentSaved": "Dokument zapisany",
    "documentDeleted": "Dokument usunięty",
    "documentSaveFailed": "Nie udało się zapisać dokumentu",
    "documentDeleteFailed": "Nie udało się usunąć dokumentu",
    "allReconciledTooltip": "Wszystkie dokumenty uzgodnione: wartość faktyczna równa zobowiązaniom, a każdy dokument (z wyłączeniem oczekujących na zatwierdzenie) ma status Opłacony lub Zatwierdzony.",
    "underCommittedTooltip": "Poniżej zobowiązań: wydatki faktyczne są niższe niż kwota zobowiązań.",
    "overCommittedTooltip": "Powyżej zobowiązań: wydatki faktyczne przekraczają kwotę zobowiązań."
  },
  "UnsavedChangesDialog": {
    "title": "Niezapisane zmiany",
    "description": "Masz niezapisane zmiany. Czy na pewno chcesz wyjść? Twoje zmiany zostaną utracone.",
    "cancel": "Kontynuuj edycję",
    "confirm": "Odrzuć zmiany",
    "beforeUnload": "Masz niezapisane zmiany. Czy na pewno chcesz wyjść?",
    "draftDescription": "Zmiany w „{{title}}” nie zostały zapisane i zostaną utracone."
  },
  "EnumFilterWidget": {
    "operator": {
      "matchAny": "jest dowolnym z",
      "matchAll": "jest wszystkimi z",
      "matchNone": "jest żadnym z",
      "empty": "jest puste",
      "notEmpty": "nie jest puste"
    },
    "searchPlaceholder": "Wyszukaj wartość",
    "emptyValue": "Wybierz…",
    "valueNotRequired": "Brak wymaganych wartości"
  },
  "DateFilterCustomDialog": {
    "title": "Własna data lub przedział",
    "enterHumanDate": "Wpisz datę słownie",
    "humanPlaceholder": "np. następne 7 dni, jutro, 2025-01-14, 20 sty - 27 sty",
    "examples": "Przykłady: „następne 7 dni”, „jutro”, „20 sty - 27 sty”",
    "or": "albo",
    "setSpecificDate": "Ustaw konkretną datę",
    "single": "Pojedyncza",
    "range": "Zakres",
    "clear": "Wyczyść",
    "willApply": "Zostanie zastosowane:",
    "apply": "Zastosuj"
  },
  "DateFilterWidget": {
    "operator": {
      "between": "pomiędzy",
      "after": "po",
      "before": "przed",
      "equal": "w dniu"
    },
    "emptyValue": "Ustaw daty",
    "apply": "Zastosuj",
    "cancel": "Anuluj"
  },
  "BooleanFilterWidget": {
    "operator": {
      "is": "jest",
      "isNot": "nie jest"
    }
  },
  "NumberFilterWidget": {
    "title": "Ustaw liczbę",
    "operator": {
      "equal": "jest",
      "notEqual": "nie jest",
      "greaterThan": "większe niż",
      "greaterOrEqual": "co najmniej",
      "lessThan": "mniejsze niż",
      "lessOrEqual": "co najwyżej",
      "between": "pomiędzy"
    },
    "to": "do",
    "apply": "Zastosuj",
    "cancel": "Anuluj"
  },
  "StringFilterWidget": {
    "operator": {
      "equals": "jest",
      "contains": "zawiera",
      "notContains": "nie zawiera"
    },
    "placeholder": "Wpisz wartość",
    "emptyValue": "Ustaw wartość",
    "apply": "Zastosuj",
    "cancel": "Anuluj",
    "suggestionsIdleHint": "Zacznij pisać, aby wyszukać, lub wybierz ostatnie miejsce poniżej.",
    "suggestionsEmpty": "Brak pasujących miejsc. Spróbuj innej frazy.",
    "recentPlacesHeading": "Ostatnie",
    "useTypedText": "Użyj „{{query}}”"
  },
  "FilterWidgetAddControl": {
    "manageFilters": "Zarządzaj filtrami",
    "searchPlaceholder": "Wyszukaj filtry…",
    "emptySearch": "Brak pasujących filtrów"
  },
  "ArchivedTabs": {
    "all": "Wszystkie",
    "archived": "Zarchiwizowane"
  },
  "ActiveTabs": {
    "active": "Aktywne",
    "inactive": "Nieaktywne"
  },
  "SortableEntityTable": {
    "failedToLoadData": "Nie udało się załadować danych",
    "selectAllItems": "Zaznacz wszystkie",
    "selectItem": "Zaznacz {{key}}",
    "actionsSrOnly": "Akcje",
    "validationIssueSrOnly": "Problem z walidacją",
    "collapseRow": "Zwiń wiersz",
    "expandRow": "Rozwiń wiersz",
    "expandAllRows": "Rozwiń wszystkie wiersze",
    "collapseAllRows": "Zwiń wszystkie wiersze",
    "dragToReorder": "Zmień kolejność wiersza",
    "locked": "Zablokowane",
    "reorderSrOnly": "Zmiana kolejności",
    "clearSortToReorder": "Wyczyść sortowanie, aby zmienić kolejność"
  },
  "MediaCarousel": {
    "openMedia": "Otwórz media"
  },
  "PinViewer": {
    "empty": "Brak pinów do pokazania",
    "untitled": "Pin bez nazwy",
    "listLabel": "Piny",
    "moreActions": "Więcej akcji"
  },
  "PinMedia": {
    "unknownFile": "Nieznany plik",
    "website": "Strona",
    "githubRepo": "Repozytorium GitHub",
    "mediumPost": "Wpis na Medium"
  },
  "MediaLoadStateOverlays": {
    "imageUnavailable": "Obraz niedostępny",
    "videoUnavailable": "Wideo niedostępne"
  },
  "EntityListToolbar": {
    "searchPlaceholder": "Szukaj...",
    "resourcesSearchPlaceholder": "Szukaj zasobów...",
    "clearAllFilters": "Wyczyść wszystkie filtry"
  },
  "CoreFields": {
    "status": "Status",
    "production_date": "Data produkcji",
    "code": "Kod",
    "archived": "Zarchiwizowane",
    "userId": "Właściciel",
    "productionTypeId": "Typ produkcji",
    "resource_type_id": "Typ",
    "organisation_id": "Organizacja",
    "represented_by_id": "Agent",
    "role": "Rola",
    "tags": "Tagi",
    "groups": "Grupy",
    "emails": "E-maile",
    "phone_numbers": "Telefony",
    "websites": "Strony internetowe",
    "socials": "Media społecznościowe",
    "locations": "Lokalizacje",
    "icon": "Ikona",
    "color": "Kolor",
    "title": "Tytuł",
    "description": "Opis",
    "budget_amount": "Kwota budżetu",
    "createdAt": "Utworzone",
    "updatedAt": "Zaktualizowane"
  },
  "CalloutSpecificFields": {
    "published": "Opublikowany",
    "archived": "Zarchiwizowany",
    "slug": "Slug URL"
  },
  "ResourceSpecificFields": {
    "groupName": "Specyficzne dla zasobu",
    "contact_type": "Typ zasobu",
    "emails": "E-maile",
    "phones": "Telefony",
    "websites": "Strony internetowe",
    "socials": "Media społecznościowe",
    "user_id": "Właściciel",
    "enterprise_workspaces": "Przestrzeń",
    "enterprise_workspaces_workspaces": "Przestrzenie",
    "enterprise_workspaces_hidden": "Ukryty",
    "enterprise_workspaces_global": "Globalny"
  },
  "ContactTypes": {
    "INDIVIDUAL": "Osoba",
    "ORGANIZATION": "Organizacja",
    "LOCATION": "Lokalizacja",
    "ITEM": "Przedmiot",
    "TALENT": "Talent",
    "AGENT": "Agent"
  },
  "CustomFields": {
    "today": "Dzisiaj"
  },
  "EntityTypes": {
    "production": "Produkcja",
    "booking": "Rezerwacja",
    "resource": "Zasób",
    "expense": "Wydatek"
  },
  "FilterGroups": {
    "coreFields": "Pola podstawowe",
    "customFields": "Pola niestandardowe"
  },
  "ReconciliationsTable": {
    "collapseAllDocuments": "Zwiń wszystkie dokumenty",
    "expandAllDocuments": "Rozwiń wszystkie dokumenty",
    "lineType": "Typ pozycji",
    "updatedAt": "Zaktualizowano",
    "vendorTooltipBooking": "Rezerwacja",
    "vendorTooltipBudgetExpense": "Pozycja budżetu produkcji",
    "expenseDetailsPopover": {
      "title": "Szczegóły kosztu",
      "vendor": "Dostawca",
      "category": "Kategoria",
      "committed": "Zadeklarowano",
      "actual": "Faktycznie",
      "receipts": "Paragony",
      "edit": "Edytuj"
    }
  },
  "ReconciliationFilters": {
    "invoice_status": {
      "AWAITING_APPROVAL": "Oczekuje na zatwierdzenie",
      "APPROVED": "Zatwierdzono",
      "PAID": "Opłacono",
      "DECLINED": "Odrzucono"
    }
  },
  "ViewSwitch": {
    "gridView": "Widok kafelków",
    "listView": "Widok listy",
    "list": "Lista",
    "grid": "Kafelki"
  },
  "EntityListSortSelect": {
    "sort": "Sortuj",
    "placeholder": "Sortuj",
    "noSort": "Bez sortowania",
    "sortAsc": "(A→Z)",
    "sortDesc": "(Z→A)"
  },
  "EntityGridSelectionToolbar": {
    "selectAllItems": "Zaznacz wszystkie"
  },
  "EntityGridListItem": {
    "selectItem": "Zaznacz {{key}}",
    "deselectItem": "Odznacz {{key}}"
  },
  "EntityListRow": {
    "validationFailed": "Błąd danych",
    "validationDetailsTitle": "Szczegóły błędu walidacji",
    "tryDisplayAnyway": "Wyświetl mimo to",
    "hideUnsafePreview": "Ukryj podgląd",
    "renderCrashed": "Nie udało się wyrenderować tego elementu",
    "renderTryAgain": "Spróbuj ponownie"
  },
  "SizeMenu": {
    "trigger": "{{label}}: {{value}}"
  },
  "FilesPanel": {
    "file": "plik",
    "files": "plików",
    "deleteSelected_one": "Usuń {{count}} plik",
    "deleteSelected_few": "Usuń {{count}} pliki",
    "deleteSelected_many": "Usuń {{count}} plików",
    "deleteSelected_other": "Usuń {{count}} plików",
    "toast": {
      "deleted_one": "Plik usunięty",
      "deleted_few": "Usunięto {{count}} pliki",
      "deleted_many": "Usunięto {{count}} plików",
      "deleted_other": "Usunięto {{count}} plików",
      "deleteFailed_one": "Nie udało się usunąć pliku",
      "deleteFailed_few": "Nie udało się usunąć {{count}} plików",
      "deleteFailed_many": "Nie udało się usunąć {{count}} plików",
      "deleteFailed_other": "Nie udało się usunąć {{count}} plików"
    }
  },
  "TileSizeMenu": {
    "size": "Maks. rozmiar kafli",
    "small": "Małe",
    "medium": "Średnie",
    "large": "Duże",
    "extraLarge": "Bardzo duże"
  },
  "SortableEntityGrid": {
    "itemsAriaLabel": "Elementy",
    "loading": "Wczytywanie elementów"
  },
  "BatchActionsLayout": {
    "clearSelection": "Wyczyść zaznaczenie"
  },
  "EntityEmptyState": {
    "nothingHereYet": "Nic tu jeszcze nie ma.",
    "noResultsMatchFilters": "Brak wyników pasujących do filtrów.",
    "clearFilters": "Wyczyść filtry",
    "pageOutOfRangeTitle": "Ta strona nie istnieje",
    "pageOutOfRangeMessage": "Jesteś na stronie bez wyników. Wróć do ostatniej dostępnej strony.",
    "goToLastPage": "Przejdź do ostatniej strony"
  },
  "TableColumnManagerPopover": {
    "title": "Dostosuj kolumny",
    "shown": "Widoczne",
    "available": "Dostępne",
    "searchPlaceholder": "Szukaj pól...",
    "reset": "Resetuj",
    "apply": "Zastosuj",
    "cancel": "Anuluj",
    "fixed": "Stałe",
    "noShownResults": "Brak pasujących widocznych pól",
    "noAvailableResults": "Brak pasujących dostępnych pól",
    "triggerAriaLabel": "Zarządzaj kolumnami",
    "availableFieldsCount": "{{count}} pole",
    "availableFieldsCount_other": "{{count}} pól",
    "dragHandle": "Przeciągnij {{field}}",
    "changed": "Zmieniono",
    "showField": "Pokaż {{field}}",
    "hideField": "Ukryj {{field}}"
  },
  "TransferToWorkspaceDialog": {
    "fieldCurrentWorkspace": "Obecna przestrzeń robocza",
    "selectWorkspace": "Wybierz przestrzeń roboczą",
    "sameWorkspace": "Wybierz inną przestrzeń roboczą niż obecna",
    "save": "Przenieś",
    "transferFailed": "Przeniesienie nie powiodło się. Spróbuj ponownie."
  },
  "TransferToTeamDialog": {
    "fieldCurrentWorkspace": "Obecna przestrzeń robocza",
    "selectWorkspace": "Wybierz przestrzeń roboczą",
    "selectTeam": "Wybierz zespół",
    "save": "Przenieś",
    "transferFailed": "Przeniesienie nie powiodło się. Spróbuj ponownie."
  },
  "CustomFieldAddFlow": {
    "addTitle": "Dodaj pole niestandardowe",
    "createTitle": "Utwórz nowe pole",
    "searchPlaceholder": "Szukaj pól lub wpisz, aby utworzyć…",
    "createNamed": "Utwórz „{{name}}”",
    "addAsNewHint": "Dodaj jako nowe pole niestandardowe",
    "selectFieldsToAdd": "Wybierz pola do dodania",
    "fieldsSection": "Pola",
    "groupsSection": "Grupy pól",
    "groupFieldCount_one": "{{count}} pole",
    "groupFieldCount_few": "{{count}} pola",
    "groupFieldCount_many": "{{count}} pól",
    "groupFieldCount_other": "{{count}} pól",
    "groupMultiple": "Wielokrotna",
    "alreadyAdded": "Już dodane",
    "currentlyAssigned": "Obecnie przypisane ({{count}})",
    "noCatalog": "Brak dostępnych pól niestandardowych. Utwórz je poniżej.",
    "noFieldsAvailable": "Brak dostępnych pól",
    "noFieldsAvailable_search": "Brak pól pasujących do wyszukiwania",
    "saveFields": "Zapisz pola",
    "cancel": "Anuluj",
    "createAndAssign": "Utwórz i przypisz",
    "stageDescription_search": "Przeszukaj istniejące pola niestandardowe lub utwórz nowe.",
    "stageDescription_create": "Skonfiguruj nowe pole niestandardowe.",
    "back": "Wstecz",
    "nameValidation_required": "Nazwa jest wymagana.",
    "nameValidation_minLength": "Nazwa musi zawierać co najmniej 3 znaki.",
    "nameValidation_duplicate": "Pole niestandardowe o tej nazwie już istnieje."
  },
  "IconPicker": {
    "placeholder": "Wybierz ikonę"
  },
  "ColorPicker": {
    "areaLabel": "Nasycenie i jasność",
    "hueLabel": "Odcień",
    "placeholder": "Wybierz kolor",
    "hexInputLabel": "Kolor hex",
    "hexInputPlaceholder": "#000000"
  },
  "ColorIconPicker": {
    "placeholder": "Wybierz ikonę i kolor"
  },
  "ResourceTypeIconPicker": {
    "placeholder": "Wybierz ikonę"
  },
  "FullPageErrorLog": {
    "copy": "Kopiuj",
    "copied": "Skopiowano"
  },
  "common": {},
  "SchemaForm": {
    "contact": {
      "row": {
        "EMAIL": "E-mail {{index}}",
        "PHONE": "Telefon {{index}}",
        "SOCIAL": "Profil społecznościowy {{index}}",
        "WEBSITE": "Strona {{index}}"
      },
      "add": {
        "EMAIL": "Dodaj e-mail",
        "PHONE": "Dodaj telefon",
        "SOCIAL": "Dodaj profil społecznościowy",
        "WEBSITE": "Dodaj stronę"
      },
      "placeholder": {
        "EMAIL": "Adres e-mail",
        "PHONE": "Numer telefonu",
        "SOCIAL": "Nazwa w serwisie społecznościowym",
        "WEBSITE": "Adres strony"
      },
      "looksLike": {
        "EMAIL": "Wygląda na kilka adresów e-mail ({{count}}).",
        "PHONE": "Wygląda na kilka numerów telefonu ({{count}}).",
        "SOCIAL": "Wygląda na kilka profili ({{count}}).",
        "WEBSITE": "Wygląda na kilka stron ({{count}})."
      },
      "error": {
        "platformRequired": "Wybierz serwis albo wklej link do profilu.",
        "notAnEmail": "To nie wygląda na adres e-mail.",
        "notAWebsite": "To nie wygląda na adres strony.",
        "valueRequired": "Wpisz wartość albo usuń wiersz."
      },
      "hint": {
        "phoneUnreadable": "Nie da się sprawdzić tego numeru. Zapisze się tak, jak go wpisano.",
        "phoneIncomplete": "Ten numer wygląda na za krótki lub za długi dla +{{code}}. Zapisze się tak, jak go wpisano.",
        "phoneTrunkZero": "Po kierunkowym kraju początkowe 0 się pomija.",
        "duplicate": "Tak samo jak wiersz {{row}}."
      },
      "pasted": "Wklejono z dodanym kierunkowym.",
      "keepAsPasted": "Zostaw jak wklejono: {{value}}",
      "splitInto_one": "Podziel na {{count}} wiersz",
      "splitInto_few": "Podziel na {{count}} wiersze",
      "splitInto_many": "Podziel na {{count}} wierszy",
      "splitInto_other": "Podziel na {{count}} wiersza",
      "use": "Użyj {{fix}}",
      "goOn": "aby przejść dalej",
      "primary": "Główny",
      "countryFor": "Kraj: {{row}}",
      "platformFor": "Serwis: {{row}}",
      "labelFor": "Etykieta: {{row}}",
      "label": "Etykieta",
      "remove": "Usuń: {{what}}"
    },
    "location": {
      "placeholder": "Wpisz lub wyszukaj miejsce"
    },
    "reference": {
      "select": "Wybierz: {{noun}}",
      "search": "Szukaj: {{noun}}",
      "clear": "Wyczyść wybór"
    },
    "list": {
      "manage": "Zarządzaj: {{title}}",
      "remove": "Usuń",
      "removeQuestion": "Usunąć „{{item}}”?",
      "newItem": "Nowy wpis: {{item}}",
      "copy": "Kopiuj: {{text}}",
      "moveUp": "Przesuń w górę: {{label}}",
      "moveDown": "Przesuń w dół: {{label}}",
      "moved": "Przesunięto na pozycję {{position}} z {{count}}.",
      "putBack": "Odłożono na pozycję {{position}} z {{count}}.",
      "pickedUp": "Podniesiono „{{label}}”. Strzałki w górę i w dół przesuwają, Spacja odkłada, Escape przywraca.",
      "removed": "Usunięto „{{label}}”."
    },
    "unit": {
      "overriddenIn": "Nadpisane w: {{workspaces}}",
      "inheritFromGlobal": "Przywróć wartość globalną",
      "inheritLabel": "Przywróć wartość globalną: {{title}}",
      "inheritFailed": "Nie udało się przywrócić wartości globalnej",
      "inherited": "Wartość globalna",
      "overridden": "Nadpisane tutaj",
      "cancelEditing": "Anuluj edycję: {{title}}",
      "readOnly": "{{title}}: tylko do odczytu",
      "edit": "Edytuj: {{title}}",
      "noValue": "brak wartości"
    },
    "validation": {
      "required": "Pole {{label}} jest wymagane",
      "notANumber": "{{label}} musi być liczbą",
      "wholeNumber": "{{label}} musi być liczbą całkowitą",
      "wholeInches": "{{label}} musi być całkowitą liczbą cali",
      "outOfRange": "{{label}} musi mieścić się w zakresie od {{min}} do {{max}}",
      "invalidOption": "{{label}}: nieprawidłowa opcja",
      "invalidProject": "{{label}}: nieprawidłowy projekt",
      "invalidDate": "{{label}}: nieprawidłowa data",
      "invalidDateRange": "{{label}}: nieprawidłowy zakres dat",
      "dateRangeOrder": "{{label}}: data początkowa nie może być późniejsza niż końcowa",
      "invalidUrl": "Wpisz prawidłowy adres URL",
      "invalidEmail": "Wpisz prawidłowy adres e-mail",
      "tagsNotAllowed": "Tworzenie nowych tagów jest wyłączone",
      "invalidAmount": "Nieprawidłowa kwota",
      "negativeAmount": "Kwota nie może być ujemna",
      "noDecimals": "Kwoty w {{currency}} nie mogą mieć części dziesiętnej",
      "tooManyDecimals_one": "Kwota może mieć najwyżej {{count}} miejsce po przecinku",
      "tooManyDecimals_few": "Kwota może mieć najwyżej {{count}} miejsca po przecinku",
      "tooManyDecimals_many": "Kwota może mieć najwyżej {{count}} miejsc po przecinku",
      "tooManyDecimals_other": "Kwota może mieć najwyżej {{count}} miejsca po przecinku",
      "billingUnit": "Jednostka rozliczenia musi być dzienna, godzinowa lub stała",
      "invalidPercent": "{{label}}: wpisz liczbę całkowitą od 0 do 100"
    },
    "readOnlyReason": {
      "noCapability": "Nie masz uprawnień do edycji tego pola",
      "noCapabilityResource": "Nie masz uprawnień do edycji tego zasobu",
      "otherWorkspace": "Przełącz się na ten workspace, aby edytować jego wartości",
      "archivedWorkspace": "Ten workspace jest zarchiwizowany",
      "displayOnly": "Widok tylko do odczytu",
      "lockedByType": "To pole jest zablokowane przez typ zasobu"
    },
    "badge": {
      "overriddenCount_one": "{{count}} pole ma tu własną wartość zamiast globalnej",
      "overriddenCount_few": "{{count}} pola mają tu własne wartości zamiast globalnych",
      "overriddenCount_many": "{{count}} pól ma tu własne wartości zamiast globalnych",
      "overriddenCount_other": "{{count}} pola mają tu własne wartości zamiast globalnych",
      "inherited": "Pokazuje wartość globalną. Zapis tutaj nada tej przestrzeni własną.",
      "overridden": "Ta przestrzeń ma własną wartość; globalna nie jest tu używana.",
      "newRow": "Dodane w tej edycji; zapisze się razem z listą."
    },
    "partRequired": {
      "name": {
        "firstName": "Podaj imię.",
        "lastName": "Podaj nazwisko."
      },
      "contactDetails": {
        "type": "Wybierz typ.",
        "value": "Wpisz wartość."
      },
      "currency": {
        "currency": "Wybierz walutę."
      },
      "measurementLegacy": {
        "unit": "Wybierz jednostkę."
      },
      "tags": {
        "tagName": "Podaj nazwę tagu."
      },
      "groups": {
        "groupName": "Podaj nazwę grupy."
      }
    },
    "saveInvalidData": "Nie udało się zapisać: część zapisanych danych jest nieprawidłowa. Sprawdź pola i spróbuj ponownie.",
    "jump": {
      "title": "Przejdź do pola",
      "placeholder": "Szukaj pola lub wartości…",
      "empty": "Żadne pole ani wartość nie pasuje",
      "readOnly": "Tylko do odczytu"
    }
  },
  "OverflowTabs": {
    "showMore": "Pokaż jeszcze {{count}}",
    "pinned": "Widoczna tutaj, bo jest wybrana"
  },
  "DiscussionThread": {
    "today": "Dzisiaj",
    "yesterday": "Wczoraj"
  },
  "SplitViewLayout": {
    "resize": "Zmień szerokość panelu",
    "resizeHint": "Przeciągnij lub użyj strzałek, aby zmienić szerokość. Kliknij dwukrotnie, aby przywrócić."
  },
  "SplitViewColumn": {
    "close": "Zamknij panel",
    "maximize": "Powiększ panel",
    "restore": "Przywróć panel"
  },
  "GalleryEditor": {
    "addToGallery": "Dodaj do galerii",
    "removeFromGallery": "Usuń z galerii",
    "addLink": "Dodaj",
    "cover": "Okładka",
    "loadingPreview": "Wczytywanie podglądu",
    "clearLink": "Wyczyść link",
    "galleryLabel": "Galeria",
    "loadingGallery": "Wczytywanie galerii",
    "dropHere": "Upuść tu zdjęcie z panelu",
    "added": "Dodane",
    "dragIntoGallery": "Przeciągnij {{name}} do galerii"
  },
  "FieldChooser": {
    "search": "Szukaj pól",
    "remove": "Usuń {{field}}",
    "noMatches": "Żadne pole nie pasuje do „{{query}}”."
  },
  "ResourcePicker": {
    "added": "Dodano",
    "cancel": "Anuluj",
    "allWorkspaces": "Wszystkie workspace’y",
    "results": "Wyniki",
    "loadFailed": "Nie udało się wczytać zasobów.",
    "rowFailed": "Nie udało się wczytać.",
    "unnamed": "Zasób bez nazwy",
    "loading": "Wczytywanie",
    "noRole": "Brak roli",
    "noRate": "Brak stawki",
    "more": "+{{count}}",
    "count_one": "{{count}} wynik",
    "count_few": "{{count}} wyniki",
    "count_many": "{{count}} wyników",
    "count_other": "{{count}} wyniku",
    "picturesFailed": "Nie udało się wczytać zdjęć.",
    "noPictures": "Brak zdjęć",
    "openPictures": "Otwórz zdjęcia",
    "morePicturesLabel_one": "jeszcze {{count}} zdjęcie",
    "morePicturesLabel_few": "jeszcze {{count}} zdjęcia",
    "morePicturesLabel_many": "jeszcze {{count}} zdjęć",
    "morePicturesLabel_other": "jeszcze {{count}} zdjęcia",
    "openPicturesOf_one": "Otwórz {{count}} zdjęcie: {{name}}",
    "openPicturesOf_few": "Otwórz {{count}} zdjęcia: {{name}}",
    "openPicturesOf_many": "Otwórz {{count}} zdjęć: {{name}}",
    "openPicturesOf_other": "Otwórz {{count}} zdjęcia: {{name}}",
    "noPicturesYet": "Nie ma jeszcze zdjęć",
    "onlyThisPicture": "Tylko to zdjęcie",
    "picturePosition": "{{index}} / {{count}}",
    "drag": "Przeciągnij",
    "details": "Szczegóły",
    "backToResults": "Wróć do wyników",
    "noneOpen": "Otwórz wynik, żeby zobaczyć tu jego szczegóły.",
    "picked_one": "{{count}} zaznaczony",
    "picked_few": "{{count}} zaznaczone",
    "picked_many": "{{count}} zaznaczonych",
    "picked_other": "{{count}} zaznaczonego",
    "clear": "Wyczyść"
  },
  "ScopeBadge": {
    "allWorkspaces": "Wszystkie workspace’y",
    "createsIn": {
      "team": "Nowe elementy powstają w workspace {{workspace}}, w zespole {{team}}.",
      "workspace": "Nowe elementy powstają w workspace {{workspace}}.",
      "organization": "Nowe elementy powstają dla całej organizacji, poza workspace’ami."
    },
    "belongsTo": {
      "team": "Ten element należy do workspace {{workspace}}, do zespołu {{team}}.",
      "workspace": "Ten element należy do workspace {{workspace}}.",
      "organization": "Ten element należy do całej organizacji, nie do workspace."
    },
    "lists": {
      "team": "Pokazuje tylko dane workspace {{workspace}}, zespołu {{team}}.",
      "workspace": "Pokazuje tylko dane workspace {{workspace}}.",
      "organization": "Pokazuje dane wszystkich workspace’ów organizacji."
    }
  },
  "ChooseTeamDialog": {
    "workspace": "Workspace",
    "team": "Zespół",
    "selectWorkspace": "Wybierz workspace",
    "selectTeam": "Wybierz zespół",
    "continue": "Dalej"
  }
}
